import Dropzone from './Dropzone.jsx';

export default Dropzone;
